import { render, staticRenderFns } from "./ShopDocumentsData.vue?vue&type=template&id=b8935e68&"
import script from "./ShopDocumentsData.vue?vue&type=script&lang=js&"
export * from "./ShopDocumentsData.vue?vue&type=script&lang=js&"
import style0 from "./ShopDocumentsData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports